<script setup>
import {
  ActionBar,
  ActionBarContent,
  ActionBarSeparator,
} from "@/shared/ui/action-bar";
import { StepperTrigger } from "@/shared/ui/stepper";
import Button from "@/shared/ui/button/Button.vue";

defineProps({
  open: { type: Boolean, default: false },
  storageKey: { type: String, default: "" },
  showStepper: { type: Boolean, default: false },
  stepperOpen: { type: Boolean, default: false },
  doneCount: { type: Number, default: 0 },
  totalSteps: { type: Number, default: 0 },
  progress: { type: Number, default: 0 },
  hasPrev: { type: Boolean, default: false },
  hasNext: { type: Boolean, default: false },
});

defineEmits(["prev", "next", "update:stepperOpen"]);
</script>

<template>
  <ActionBar :open="open" :close-on-escape="false">
    <ActionBarContent
      draggable
      :storage-key="storageKey"
      :aria-label="$t('Навигация по шагам')"
      class="gap-1 rounded-[var(--radius)] border-border bg-popover shadow-[0_12px_36px_-6px_rgba(16,24,40,0.24),0_3px_8px_-2px_rgba(16,24,40,0.14)]"
    >
      <template v-if="showStepper">
        <ActionBarSeparator class="mx-1.5" />
        <StepperTrigger
          :open="stepperOpen"
          :done-count="doneCount"
          :total-steps="totalSteps"
          :progress="progress"
          class="!h-8"
          @update:open="$emit('update:stepperOpen', $event)"
        />
      </template>

      <ActionBarSeparator class="mx-1.5" />

      <div class="flex items-center gap-2">
        <Button
          variant="ghost"
          size="sm"
          :disabled="!hasPrev"
          class="bg-muted/30"
          @click="$emit('prev')"
        >
          <svg-icon name="huge-chevron-left" class="w-4 h-4" />
          {{ $t("Назад") }}
        </Button>
        <Button
          variant="default"
          size="sm"
          :disabled="!hasNext"
          @click="$emit('next')"
        >
          {{ $t("Далее") }}
          <svg-icon name="huge-chevron-right" class="w-4 h-4" />
        </Button>
      </div>
    </ActionBarContent>
  </ActionBar>
</template>
